import { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Avatar,
  Divider,
} from '@mui/material';
import { Send } from '@mui/icons-material';

const TYPE_COLORS = {
  COMENTARIO: '#1565c0',
  OBSERVACION: '#e65100',
  RESPUESTA: '#2e7d32',
  SISTEMA: '#78909c',
};

const CommentSection = ({ comments = [], onAddComment, loading = false }) => {
  const [message, setMessage] = useState('');

  const handleSubmit = async () => {
    if (!message.trim()) return;
    await onAddComment({ message: message.trim(), type: 'COMENTARIO' });
    setMessage('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  const formatDate = (date) =>
    new Date(date).toLocaleDateString('es-ES', {
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
    });

  return (
    <Box>
      <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 2 }}>
        Comentarios ({comments.length})
      </Typography>

      <Box sx={{ maxHeight: 400, overflowY: 'auto', mb: 2 }}>
        {comments.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
            Sin comentarios aun
          </Typography>
        ) : (
          comments.map((comment, idx) => (
            <Box key={comment._id || idx}>
              <Box sx={{ display: 'flex', gap: 1.5, py: 1.5 }}>
                <Avatar
                  sx={{
                    width: 28,
                    height: 28,
                    fontSize: '0.75rem',
                    bgcolor: TYPE_COLORS[comment.type] || '#78909c',
                    borderRadius: 0,
                  }}
                >
                  {comment.author?.nombre?.charAt(0) || 'S'}
                </Avatar>
                <Box sx={{ flex: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.25 }}>
                    <Typography variant="body2" fontWeight={600} sx={{ fontSize: '0.8125rem' }}>
                      {comment.author?.nombre || 'Sistema'}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {formatDate(comment.createdAt)}
                    </Typography>
                    {comment.type === 'SISTEMA' && (
                      <Typography
                        variant="caption"
                        sx={{ color: '#78909c', fontStyle: 'italic' }}
                      >
                        automatico
                      </Typography>
                    )}
                  </Box>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: '0.8125rem',
                      color: comment.type === 'SISTEMA' ? '#78909c' : 'text.primary',
                      fontStyle: comment.type === 'SISTEMA' ? 'italic' : 'normal',
                    }}
                  >
                    {comment.message}
                  </Typography>
                </Box>
              </Box>
              {idx < comments.length - 1 && <Divider />}
            </Box>
          ))
        )}
      </Box>

      <Box sx={{ display: 'flex', gap: 1 }}>
        <TextField
          fullWidth
          size="small"
          placeholder="Escribe un comentario..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={handleKeyDown}
          multiline
          maxRows={3}
          sx={{
            '& .MuiOutlinedInput-root': { borderRadius: 0, fontSize: '0.875rem' },
          }}
        />
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!message.trim() || loading}
          sx={{ minWidth: 44, borderRadius: 0, px: 1.5 }}
        >
          <Send sx={{ fontSize: 18 }} />
        </Button>
      </Box>
    </Box>
  );
};

export default CommentSection;
